import apiClient from "./client";

/** One admin / operator account with its counts (account_overview.php). */
export const accountOverview = (id) => apiClient.get(`/account_overview.php?id=${id}`);

/** Partners / branches of a broadband provider login (super admin only). */
export const providerPartners = (body) => apiClient.post("/provider_partners.php", { action: "partners", ...body });
export const providerBranches = (body) => apiClient.post("/provider_partners.php", { action: "branches", ...body });
export const providerAddBranch = (body) => apiClient.post("/provider_partners.php", { action: "add_branch", ...body });

export const addBalance = (body) => apiClient.post("/addBalance.php", body);
export const debitBalance = (body) => apiClient.post("/debitBalance.php", body);
